import { AlertMessageComponent } from './alert-message.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


@NgModule({
  declarations: [AlertMessageComponent],
  exports: [AlertMessageComponent],
  imports: [
    CommonModule,
  ]
})
export class AlertMessageModule { }
